/* ============================================
   Countdown Bar (Geri Sayım Barı)
   ============================================ */
(function () {
  'use strict';

  var REDUCED_MOTION =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var FLIP_DURATION = 580;
  var SLIDE_DURATION = 320;

  function pad(n) {
    n = Math.max(0, n);
    return (n < 10 ? '0' : '') + n;
  }

  function CountdownBar(el) {
    if (el.__cdb) return;
    el.__cdb = this;

    this.el = el;
    this.designMode = !!(window.Shopify && window.Shopify.designMode);
    this.end = new Date(el.getAttribute('data-end') || '').getTime();
    var startAttr = el.getAttribute('data-start');
    this.start = startAttr ? new Date(startAttr).getTime() : null;
    this.behavior = el.getAttribute('data-expired-behavior') || 'hide';
    this.urgentMs = (parseInt(el.getAttribute('data-urgent-minutes'), 10) || 0) * 60000;
    this.timer = null;
    this.startTimer = null;
    this.expiredEl = el.querySelector('[data-cdb-expired]');
    this.storageKey =
      'cdb-dismissed-' +
      (el.getAttribute('data-section-id') || '') +
      '-' +
      (el.getAttribute('data-end') || '');

    this.units = {};
    var self = this;
    el.querySelectorAll('[data-cdb-unit]').forEach(function (unit) {
      self.units[unit.getAttribute('data-cdb-unit')] = unit;
    });

    var closeBtn = el.querySelector('[data-cdb-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.dismiss();
      });
    }

    if (isNaN(this.end)) {
      if (!this.designMode) this.hide();
      return;
    }

    if (!this.designMode) {
      var referrer = el.getAttribute('data-target-referrer');
      if (referrer && document.referrer.indexOf(referrer) === -1) {
        this.hide();
        return;
      }

      if (this.isDismissed()) {
        this.hide();
        return;
      }

      if (this.start && Date.now() < this.start) {
        this.hide();
        this.waitForStart();
        return;
      }
    }

    this.run();
  }

  CountdownBar.prototype = {
    run: function () {
      var self = this;
      this.show();
      this.tick(false);
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(function () {
        self.tick(true);
      }, 1000);
    },

    tick: function (animate) {
      var diff = this.end - Date.now();

      if (diff <= 0) {
        this.expire();
        return;
      }

      if (this.urgentMs > 0) {
        this.el.classList.toggle('is-urgent', diff <= this.urgentMs);
      }

      var total = Math.floor(diff / 1000);
      var days = Math.floor(total / 86400);
      var hours = this.units.days
        ? Math.floor((total % 86400) / 3600)
        : Math.floor(total / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;

      this.setUnit('days', days, animate);
      this.setUnit('hours', hours, animate);
      this.setUnit('minutes', minutes, animate);
      this.setUnit('seconds', seconds, animate);
    },

    setUnit: function (name, value, animate) {
      var unit = this.units[name];
      if (!unit) return;

      var str = pad(value);
      if (animate && REDUCED_MOTION) animate = false;

      var flip = unit.querySelector('[data-cdb-flip]');
      if (flip) {
        this.setFlip(unit, flip, str, animate);
        return;
      }

      var slide = unit.querySelector('[data-cdb-slide]');
      if (slide) {
        this.setSlide(slide, str, animate);
        return;
      }

      var valueEl = unit.querySelector('[data-cdb-value]');
      if (!valueEl || valueEl.textContent === str) return;
      valueEl.textContent = str;
      if (animate) {
        valueEl.classList.remove('cdb-pop');
        void valueEl.offsetWidth;
        valueEl.classList.add('cdb-pop');
      }
    },

    setFlip: function (unit, flip, str, animate) {
      var top = flip.querySelector('[data-top]');
      var bottom = flip.querySelector('[data-bottom]');
      var flipTop = flip.querySelector('[data-flip-top]');
      var flipBottom = flip.querySelector('[data-flip-bottom]');
      var current = top.textContent;

      if (current === str) return;

      if (!animate) {
        top.textContent = str;
        bottom.textContent = str;
        flipTop.textContent = str;
        flipBottom.textContent = str;
        return;
      }

      /* Üst panel eski değeri gösterip aşağı kapanır, alt panel yeni değerle açılır */
      flipTop.textContent = current;
      flipBottom.textContent = str;
      top.textContent = str;
      flip.classList.add('is-flipping');

      clearTimeout(unit.__cdbFlipTimeout);
      unit.__cdbFlipTimeout = setTimeout(function () {
        bottom.textContent = str;
        flipTop.textContent = str;
        flip.classList.remove('is-flipping');
      }, FLIP_DURATION);
    },

    setSlide: function (holder, str, animate) {
      var current = holder.querySelector('[data-cdb-value]:not(.cdb-slide__out)');
      if (!current || current.textContent === str) return;

      if (!animate) {
        current.textContent = str;
        return;
      }

      var next = current.cloneNode(false);
      next.textContent = str;
      next.classList.add('cdb-slide__in');
      holder.appendChild(next);
      current.classList.add('cdb-slide__out');

      setTimeout(function () {
        if (current.parentNode) current.parentNode.removeChild(current);
        next.classList.remove('cdb-slide__in');
      }, SLIDE_DURATION);
    },

    expire: function () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.el.classList.remove('is-urgent');
      this.setUnit('days', 0, false);
      this.setUnit('hours', 0, false);
      this.setUnit('minutes', 0, false);
      this.setUnit('seconds', 0, false);

      if (this.behavior === 'message') {
        if (this.expiredEl) {
          this.expiredEl.hidden = false;
          var timerEl = this.el.querySelector('[data-cdb-timer]');
          if (timerEl) timerEl.style.display = 'none';
        }
        return;
      }

      if (this.behavior === 'hide' && !this.designMode) {
        this.hide();
      }
      /* 'zero' davranışında sayaç 00:00:00 olarak görünür kalır */
    },

    waitForStart: function () {
      var self = this;
      this.startTimer = setInterval(function () {
        if (Date.now() >= self.start) {
          clearInterval(self.startTimer);
          self.startTimer = null;
          self.run();
        }
      }, 1000);
    },

    isDismissed: function () {
      try {
        return !!window.localStorage.getItem(this.storageKey);
      } catch (e) {
        return false;
      }
    },

    dismiss: function () {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch (e) {
        /* localStorage kullanılamıyorsa sadece bu oturumda gizlenir */
      }

      var self = this;
      this.el.classList.add('is-dismissed');
      setTimeout(function () {
        self.hide();
      }, 260);
    },

    show: function () {
      this.el.style.display = '';
    },

    hide: function () {
      this.el.style.display = 'none';
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    destroy: function () {
      if (this.timer) clearInterval(this.timer);
      if (this.startTimer) clearInterval(this.startTimer);
      this.el.__cdb = null;
    }
  };

  function init(scope) {
    var root = scope || document;
    var elements = root.querySelectorAll('[data-countdown-bar]');
    elements.forEach(function (el) {
      new CountdownBar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Tema düzenleyicisi desteği */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('[data-countdown-bar]');
    if (el && el.__cdb) el.__cdb.destroy();
  });
})();
